import { Route } from '../store/cms/models/route';

export enum PageRouteMapKeys {
    IsRegularDriver = 'isregulardriver',
    HouseholdMemberEmploymentStatus = 'householdmemberemploymentstatus',
    HouseholdMemberUnemployedStatus = 'householdmemberunemployedstatus',
    HouseholdMemberWorkdaysFromHome = 'householdmemberworkdaysfromhome',
    HouseholdMemberLicenceType = 'householdmemberlicencetype',
    HomeContentReplacementValue = 'homecontentreplacementvalue',
    EmploymentStatus = 'employmentstatus',
    UnemployedStatus = 'unemployedstatus',
    WorkdaysFromHome = 'workdaysfromhome',
    ResidentialAddress = 'residentialaddress',
    CarParkedAddressHome = 'carparkedaddresshome',
    CarAddressSuburbWork = 'caraddresssuburbwork',
    RiskAddressPage = 'riskaddresspage',
    CarParkedMethodHome = 'carparkedmethodhome',
    CarParkedMethodWork = 'carparkedmethodwork',
    HouseholdMemberMaritalStatus = 'householdmembermaritalstatus',
    CashbackDetailsPage = 'cashbackpage',
}

export type PageRouteMap = {
    [selector in PageRouteMapKeys]: Route;
};
